const DuplicateTableKeys: { [dictionary: string]: string } = {
  number: 'number',
  surname: 'surname',
  name: 'name',
  dateOfBirth: 'dateOfBirth',
  contacts: 'contacts',
  lastActivity: 'lastActivity',
};

export const columnKeys = [
  DuplicateTableKeys.number,
  DuplicateTableKeys.name,
  DuplicateTableKeys.surname,
  DuplicateTableKeys.dateOfBirth,
  DuplicateTableKeys.contacts,
  DuplicateTableKeys.lastActivity,
];

export const columnStyles = {
  [DuplicateTableKeys.number]: {
    minWidth: '100px',
    width: '15%',
  },
  [DuplicateTableKeys.surname]: {
    minWidth: '150px',
    width: '20%',
  },
  [DuplicateTableKeys.name]: {
    minWidth: '100px',
    width: '20%',
  },
  [DuplicateTableKeys.dateOfBirth]: {
    minWidth: '100px',
    width: '20%',
  },
  [DuplicateTableKeys.contacts]: {
    minWidth: '100px',
    width: '25%',
  },
};
